export * from '@fhs/routing/src/routes/(drawer)/account/payment';
export { default } from '@fhs/routing/src/routes/(drawer)/account/payment';
